import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class LocalStorageService {

  private areaState = new Subject<boolean>();

  public areaObs = new Subject<string>();
  public countObs = new Subject<string>();
  public countTotals = new Subject<number>();
  public extraTotals = new Subject<string>();
  public monthObs = new Subject<string>();
  public nameArray: string[] = [];
  public nameObs = new Subject<string>();
  public prodObs = new Subject<string>();
  public selectionsObs = new Subject<string>();

  public areaClear(): void {
    this.areaObs.next(localStorage.areaSelection);
  }

  private addCounts(existingCount: string, newCount: string): string {
    const existingCountInt: number = this.filterInt(existingCount);
    const newCountInt: number = this.filterInt(newCount);
    const returnCount = existingCountInt + newCountInt;
    return returnCount.toString();
  }

  public areaSend(status: boolean) {
    this.areaState.next(status);
  }

  public areaReturn(): Observable<any> {
    return this.areaState.asObservable();
  }

  public areaListener(): Observable<string> {
    return this.areaObs.asObservable();
  }

  public areaWrite(area: string): void {
    localStorage.setItem('areaSelection', area);
    this.areaObs.next(area);
  }

  public checkSelected(name: string): boolean {
    const products: string = localStorage.getItem('productSelection');
    let nameArray: string[];
    let matchingVal: string;

    if (products === null || products === undefined) {
      return false;
    } else {
      if (products.indexOf(' ') === -1) {
        if (name === products) {
          return true;
        } else {
          return false;
        }
      } else if (products.indexOf(' ') > -1) {
        nameArray = products.split(' ');
        for (let i = 0; i < nameArray.length; i++) {
          if (name === nameArray[i]) {
            matchingVal = nameArray[i];
          }
        }
        if (name === matchingVal) {
          return true;
        } else {
          return false;
        }
      }
    }
  }

  public countClear(): void {
    this.countObs.next(localStorage.productCount);
  }

  public countListener(): Observable<string> {
    return this.countObs.asObservable();
  }

  private countNames(): string[] {
    // this method assumes that there are counts stored
    const countSelections = localStorage.productCount;
    const nameArray: string[] = [];

    if (countSelections.indexOf(' ') > -1) {
      const selectionArray = countSelections.split(' ');
      for (let i = 0; i < selectionArray.length; i++) {
        const tempCount = selectionArray[i].split('-');
        // check tempCount[0] doens't exist in nameArray
        if (nameArray.indexOf(tempCount[0]) === -1) {
          nameArray.push(tempCount[0]);
        }
      }
      return nameArray;
    } else {
      const selectionArray = countSelections.split('-');
      nameArray.push(selectionArray[0]);
      return nameArray;
    }
  }

  public countWrite(count: string, name: string): void {
    const storedCounts: string = localStorage.productCount;
    let prodCount;

    if (count !== null || count !== undefined) {
      prodCount = count;
    } else {
      prodCount = 1;
    }

    if (storedCounts === undefined || storedCounts === null) {
      // ls has no value
      localStorage.setItem('productCount', name + '_' + prodCount);
      this.countObs.next(count);
    } else if (storedCounts.length) {
      const splitCheck: string[] = storedCounts.split(' ');

      if (storedCounts.indexOf(name) > -1) {
        const newArray: string[] = [];
        // tslint:disable-next-line: no-shadowed-variable
        let newItem: string;
        for (let i = 0; i < splitCheck.length; i++) {
          if (splitCheck[i].indexOf(name) > -1) {
            newItem = splitCheck[i];
          } else if (splitCheck[i].indexOf(name) === -1) {
            newArray.push(splitCheck[i]);
          }
        }
        newArray.push(name + '_' + prodCount);
        const toSet = newArray.join(' ');
        localStorage.setItem('productCount', toSet);
        this.countObs.next(prodCount + '');
      } else if (storedCounts.indexOf(name) === -1) {
        splitCheck.push(name + '_' + prodCount);
        localStorage.setItem('productCount', splitCheck.join(' '));
        this.countObs.next(prodCount);
      } else {
        console.log('an unknown error ocured');
      }
    }
  }

  public customizations(value: string): void {
    localStorage.setItem(value, value);
  }

  public customizationCheck(value: string): boolean {
    localStorage.getItem(value);
    if (value === localStorage.getItem(value)) {
      return true;
    }
  }

  public filterInt(value: string): number {
    if (/^[-+]?(\d+|Infinity)$/.test(value)) {
      return Number(value);
    } else {
      return NaN;
    }
  }

  public getCount(name: string): number {
    const storedCounts: string = localStorage.productCount;

    if (storedCounts === null || storedCounts === undefined) {
      return 1;
    } else {
      const splitCheck: string[] = storedCounts.split(' ');
      for (let i = 0; i < splitCheck.length; i++) {
        const nameCheck: string[] = splitCheck[i].split('_');
        if (nameCheck[0] === name) {
          return parseFloat(nameCheck[1]);
        }
      }
    }
  }

  public getTotalCounts(): number {
    const storedCounts: string = localStorage.productCount;

    if (storedCounts === null || storedCounts === undefined) {
      return 0;
    } else {
      const splitCheck: string[] = storedCounts.split(' ');
      let temp: string[];
      const valueString: string[] = [];
      const valueNumbers: number[] = [];
      for (let i = 0; i < splitCheck.length; i++) {
        temp = splitCheck[i].split('_');
        valueString.push(temp[1]);
      }

      for (let i = 0; i < valueString.length; i++) {
        valueNumbers.push(parseFloat(valueString[i]));
      }
      console.log(valueNumbers.reduce( (a, b) => a + b, 0 ));
      return valueNumbers.reduce( (a, b) => a + b, 0 );
    }
  }

  public getTotalPrices(lsCost): number[] {
    const prodPrice: string[] = lsCost.split(' ');
    const costArray: number[] = [];

    for (let i = 0; i < prodPrice.length; i++) {
      const costToAdd: string[] = prodPrice[i].split('_');
      const thisCost: number = parseFloat(costToAdd[1]);
      const thisCount: number = this.getCount(costToAdd[0]);
      costArray.push(thisCost * thisCount);
    }

    // console.log(costArray);
    // console.log(costArray.reduce((a, b) => a + b, 0));
    return costArray;
  }

  public getProductCost(name: string): number {
    const prodPrices: string[] = localStorage.getItem('productsPrice').split(' ');
    for (let i = 0; i < prodPrices.length; i++) {
      const priceCheck: string[] = prodPrices[i].split('_');
      if (priceCheck[0] === name) {
        return parseFloat(priceCheck[1]);
      }
    }
  }

  public monthClear(): void {
    localStorage.removeItem('localStorage.monthSelection');
    this.monthObs.next(localStorage.monthSelection);
  }

  public monthListener(): Observable<string> {
    return this.monthObs.asObservable();
  }

  public monthWrite(month: string): void {
    if (month !== null || month !== undefined) {
      localStorage.setItem('monthSelection', month);
      this.monthObs.next(month);
    }
  }

  // public nameListener(): Observable<string> {
  //   return this.nameObs.asObservable();
  // }

  // public nameWrite(name: string): void {
  //   const prodName: string = localStorage.getItem('nameSelection');

  //   if (prodName !== null)  {
  //     if (prodName.indexOf(' ') > -1) {
  //       const prodNameArray: string[] = prodName.split(' ');

  //       if (prodNameArray.indexOf(name) === -1) {
  //         prodNameArray.push(name);
  //         localStorage.setItem('nameSelection', prodNameArray.join(' '));
  //         this.nameObs.next(name);
  //       }

  //     } else {
  //       if (prodName !== name) {
  //         const newNames: string = prodName + ' ' + name;
  //         localStorage.setItem('nameSelection', newNames);
  //         this.nameObs.next(name);
  //       } else {
  //         console.log('name is already in localStorage');
  //       }
  //     }
  //   } else {
  //     localStorage.setItem('nameSelection', name);
  //     this.nameObs.next(name);
  //   }
  // }

  public productCheck(name: string): boolean {
    const array: string[] = this.nameArray;
    for (let i = 0; i < array.length; i++) {
      if (name === array[i]) {
        return true;
      } else {
        return false;
      }
    }
  }

  public productClear(name: string): void {
    localStorage.removeItem(name);
    this.prodObs.next(name);
  }

  public productListener(): Observable<string> {
    return this.prodObs.asObservable();
  }

  public productPriceListener(): Observable<string> {
    return this.extraTotals.asObservable();
  }

  public priceWrite(priceList: string): void {
    localStorage.setItem('productsPrice', priceList);
    if (priceList !== null || priceList !== undefined) {
      this.extraTotals.next(priceList);
    }
  }

  public productPrices(name: string, cost: number): void {

    if (name !== null && name !== undefined && cost !== null && cost !== undefined) {
      const extra: string = localStorage.getItem('productsPrice');
  
      if (extra === null) {
        localStorage.setItem('productsPrice', name + '_' + cost);
        this.extraTotals.next(name + '_' + cost);
      } else {
        const extras = extra.split(' ');
        const tempArray: string[] = [];
  
        if (extra.indexOf(name) > -1) {
          console.log('found in ls');
  
          for (let i = 0; i < extras.length; i++) {
            if (extras[i].indexOf(name) > -1) {
              tempArray.push(name + '_' + cost);
            } else if (extras[i].indexOf(name) === -1) {
              tempArray.push(extras[i]);
            }
          }
          localStorage.setItem('productsPrice', tempArray.join(' '));
          this.extraTotals.next(tempArray.join(' '));
        } else if (extra.indexOf(name) === -1) {
          console.log('couldnt find in ls');
          extras.push(name + '_' + cost);
          localStorage.setItem('productsPrice', extras.join(' '));
          this.extraTotals.next(extras.join(' '));
        }
      }
    }

  }

  public productWrite(name: string): void {
    const products: string = localStorage.getItem('productSelection');

    if (products !== null) {
      if (products.split(' ') === null) {
        localStorage.setItem('productSelection', name);
        this.prodObs.next(name);
        console.log(name);
      } else {
        const nameArray = products.split(' ');
        if (nameArray.indexOf(name) === -1) {
          const existstingVals = localStorage.getItem('productSelection');
          const newVals = existstingVals + ' ' + name;
          localStorage.setItem('productSelection', newVals);
          this.prodObs.next(name);
          console.log(name);
        }
      }
    } else {
      localStorage.setItem('productSelection', name);
      this.prodObs.next(name);
      console.log(name);
    }
  }

  public productWriteNew(name: string): void {
    // localStorage.setItem('productSelection', name);
    this.prodObs.next(name);
  }

  public removePrice(prodName: string) {
    const prodCosts: string = localStorage.getItem('productsPrice');

    if (prodCosts !== null || prodCosts !== undefined) {
      if (prodCosts.indexOf(' ') === -1) {
        localStorage.removeItem('productsPrice');
        return false;
      } else if (prodCosts.indexOf(' ') > -1) {
        const selectionArray: string[] = prodCosts.split(' ');
        const returnArray: string[] = [];

        for (let i = 0; i < selectionArray.length; i++) {
          if (prodName !== selectionArray[i].split('_')[0]) {
            returnArray.push(selectionArray[i]);
          }
        }

        const returnString: string = returnArray.join(' ');
        localStorage.setItem('productsPrice', returnString);
        this.extraTotals.next(returnString);
        return returnString;
      }
    }
  }

  public removeCount(name: string): boolean {
    const productCount: string = localStorage.getItem('productCount');

    if (productCount === null || productCount === undefined) {
    } else {
      if (productCount.indexOf(' ') === -1) {
        localStorage.removeItem('productCount');
        return false;
      } else {
        const selectionArray: string[] = productCount.split(' ');
        const returnArray: string[] = [];
        for (let i = 0; i < selectionArray.length; i++) {
          console.log(selectionArray[i] + ' - ' + name);
          if (selectionArray[i].indexOf(name) === -1) {
            console.log(selectionArray[i] + ' - ' + name);
            returnArray.push(selectionArray[i]);
          }
        }
        const returnString: string = returnArray.join(' ');
        localStorage.setItem('productCount', returnString);
        this.countObs.next(returnString);
        // return returnString;
      }
      // this.totalCounts();
    }
  }

  public removeMonth(): void {
    const monthSelection: string = localStorage.getItem('monthSelection');

    if (monthSelection) {
      localStorage.removeItem('monthSelection');
      this.monthObs.next('');
    }
  }

  public removeProduct(name: string): boolean {
    const productsSelecion: string = localStorage.getItem('productSelection');

    if (productsSelecion === null || productsSelecion === undefined) {
      console.log(productsSelecion + ' (null) value detected');
      return null;
    } else {
      if (productsSelecion.split(' ').length === 1) {
        localStorage.removeItem('productSelection');
        return false;
      } else if (productsSelecion.indexOf(' ') > -1) {
        const selectionArray: string[] = productsSelecion.split(' ');
        const returnArray: string[] = [];

        for (let i = 0; i < selectionArray.length; i++) {
          if (name !== selectionArray[i]) {
            returnArray.push(selectionArray[i]);
          }
        }

        const returnString: string = returnArray.join(' ');
        localStorage.setItem('productSelection', returnString);
        return true;
      }
    }
  }

  public removeSelection(name: string): void {
    const selections: string = localStorage.getItem('selections');

    if (selections.indexOf(' ') === -1) {
      localStorage.removeItem('selections');
    } else {
      const selectionArray: string[] = selections.split(' ');
      const tempArray: string[] = [];

      if (selectionArray.length > 1) {
        console.log('multiple product');
        for (let i = 0; i < selectionArray.length; i++) {
          if (selectionArray[i].indexOf(name) === -1) {
            tempArray.push(selectionArray[i]);
          }
        }
        localStorage.setItem('selections', tempArray.join(' '));
      } else if (selectionArray.length === 1) {
        console.log('single product');
        if (selectionArray.indexOf(name) > -1) {
          localStorage.removeItem('selections');
        }
      }
    }
  }

  public selectionListener(): Observable<string> {
    return this.selectionsObs.asObservable();
  }

  public selectionsWrite(name: string, selections: string): void {
    const storedSelections: string = localStorage.selections;

    if (storedSelections === undefined || storedSelections === null) {
      // ls has no value
      localStorage.setItem('selections', selections);
      this.selectionsObs.next(selections);
    } else if (storedSelections.length) {
      const newArray: string[] = [];

      if (storedSelections.indexOf(' ') > -1) {
        const checkArray = storedSelections.split(' ');

        for (let i = 0; i < checkArray.length; i++) {
          if (checkArray[i].indexOf(name) === -1) {
            newArray.push(checkArray[i]);
          }
        }
        newArray.push(selections);
        localStorage.setItem('selections', newArray.join(' '));
        this.selectionsObs.next(newArray.join(' '));
      } else if (storedSelections.indexOf(' ') === -1) {
        if (storedSelections.indexOf(name) > -1) {
          localStorage.setItem('selections', selections);
          this.selectionsObs.next(selections);
        } else if (storedSelections.indexOf(name) === -1) {
          newArray.push(storedSelections);
          newArray.push(selections);
          localStorage.setItem('selections', newArray.join(' '));
          this.selectionsObs.next(newArray.join(' '));
        }
      } else {
        console.error(Error + ': an unknown error ocured');
      }
    }
  }

  public totalCounts(): number {
    if (localStorage.getItem('productPrice') !== null) {
      const productCost = localStorage.getItem('productPrice').split(' ');
      const costArray: number[] = [];
      for (let i = 0; i < productCost.length; i++) {
        const retrieveCost: string[] = productCost[i].split('_');
        console.log(retrieveCost);
        const prodCount: number = this.getCount(retrieveCost[0]);
        console.log(prodCount);
        const productPrice: number = parseFloat(retrieveCost[1]);
        console.log(productPrice);
        costArray.push(prodCount * productPrice);
      }
      console.log(costArray.reduce((a, b) => a + b, 0));
      return costArray.reduce((a, b) => a + b, 0);
    }
  }

  public totalListener(): Observable<number> {
    return this.countTotals.asObservable();
  }

}
